@if (selectedWorkspaceInstanceEdge) {
<div>
  <form #myForm="ngForm">
    <mat-form-field>
      <input matInput placeholder="Name" (blur)="onNameBlur()" name="selectedWorkspaceInstanceEdge.name" required type="text" maxlength="255" [(ngModel)]="selectedWorkspaceInstanceEdge.name" />
    </mat-form-field>
    <mat-form-field>
      <textarea matInput placeholder="Description" name="workspacenodedescription" [(ngModel)]="selectedWorkspaceInstanceEdge.description"></textarea>
    </mat-form-field>
    <mat-form-field>
      <input
        matTooltip="{{ selectedWorkspaceInstanceEdge.id }}"
        matInput
        placeholder="Source label"
        name="selectedWorkspaceInstanceEdge.sourceLabel"
        type="text"
        [(ngModel)]="selectedWorkspaceInstanceEdge.sourceLabel" />
    </mat-form-field>
    <mat-form-field>
      <input matInput placeholder="Target label" name="selectedWorkspaceInstanceEdge.targetLabel" type="text" [(ngModel)]="selectedWorkspaceInstanceEdge.targetLabel" />
    </mat-form-field>
    <div class="save-button-div">
      <button mat-raised-button color="primary" (click)="saveWork()" [disabled]="!myForm.form.valid || !myForm.form.dirty || locked">Save</button>
    </div>
  </form>
</div>
}
